module.exports = __webpack_public_path__ + "media/src/images/home-eade14543027b61a37de4e1ae68df7df.svg";